import BaseTween from './base-tween'

/**
 * The basic tween class used for stright tweens.
 *
 * @param  {PIXI.Sprite}  sprite            the sprite to tween
 * @param  {Array} pointsArray              the array of points to travel through
 * @param  {number}  duration               the number of frames that the tween will take to complete
 * @param  {String}  [type='smoothstep']    the type of easing
 * @param  {Boolean} [yoyo=false]           should the sprite yoyo
 * @param  {Number}  [delayBeforeRepeat=0]  Delay in frames before repeating
 */
export default class PathTween extends BaseTween {
  constructor (
    sprite,
    pointsArray,
    totalFrames,
    type = 'smoothstep',
    yoyo = false,
    delayBeforeRepeat = 0
  ) {
    super(sprite, pointsArray, totalFrames, type, yoyo, delayBeforeRepeat)
  }

  /**
   * Apply the Bezier curve to the sprite's position.
   *
   * @param  {number} curvedTime
   * @private
   */
  _modifyProperty (curvedTime) {
    sprite.x = this.easingFormulas.cubicBezier(curvedTime, this.data[0][0], this.data[1][0], this.data[2][0], this.data[3][0])
    sprite.y = this.easingFormulas.cubicBezier(curvedTime, this.data[0][1], this.data[1][1], this.data[2][1], this.data[3][1])
  }

  _setUpForYoyo () {
    this.data = this.data.reverse()
  }

  _setUpForEnd () {}
}



// WEBPACK FOOTER //
// ./charm/src/path-tween.js